import React from 'react';

const Bullet = (props: React.BaseHTMLAttributes<HTMLSpanElement>) => <span {...props}>&nbsp;&#8226;&nbsp;</span>;

export default Bullet;
